// 轻量版 i18n: 中英双语切换 (不引入 vue-i18n, 简化版本)
//
// 词典集中在 src/i18n/{zh,en}.ts; 本文件只负责语言状态与 t() 查询。
// 缺键回退链: 当前语言 → zh → 返回键名本身 (便于发现漏翻)。

import { ref, computed } from 'vue'
import { zh } from '@/i18n/zh'
import { en } from '@/i18n/en'

const STORAGE_KEY = 'alphalens:lang'

const messages: Record<string, Record<string, string>> = { zh, en }

const currentLang = ref<string>(
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) || 'zh' : 'zh'
)

function setLang(lang: string): void {
  if (lang !== currentLang.value) {
    currentLang.value = lang
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, lang)
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en'
    }
  }
}

function t(key: string): string {
  const dict = messages[currentLang.value] || messages.zh
  return dict[key] || messages.zh[key] || key
}

export function useI18nLite() {
  return {
    lang: computed(() => currentLang.value),
    t,
    setLang,
    messages,
  }
}

// 初始化 html lang
if (typeof document !== 'undefined') {
  document.documentElement.lang = currentLang.value === 'zh' ? 'zh-CN' : 'en'
}
